/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck1">
<label class="accordion-label" for="chck1">Mengajukan pinjaman kembali setelah melunasi pinjaman sebelumnya</label>
<div class="accordion-content">
<p>
Kami informasikan terkait pengajuan kembali dapat melakukan pengajuan ulang pada aplikasi Easycash dan untuk pengajuan akan dilakukan proses review atau penilaian kembali.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">Tenor pinjaman Easycash</label>
<div class="accordion-content">
<p>
Tenor pinjaman Easycash saat ini 15 hari dan 1 bulan per periode. Tenor pinjaman merupakan hasil penilaian dari proses review.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Kendala kode verifikasi</label>
<div class="accordion-content">
<p>
Pengajuan kode OTP saat ini dapat melalui pesan suara, Whatsapp dan SMS. Pastikan sinyal Anda stabil untuk penerimaan kode OTP tersebut.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">Kendala aplikasi verifikasi wajah pada saat pengajuan</label>
<div class="accordion-content">
<p>
Untuk pengambilan verifikasi wajah, pastikan Anda sudah memberikan akses kamera dan mengikuti langkah-langkah yang diinformasikan pada aplikasi Easycash. Pastikan pencahayaan yang terang serta jaringan internet yang lancar pada perangkat.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">Bagaimana cara mengajukan pinjaman di Easycash</label>
<div class="accordion-content">
<p>
Mengenai registrasi aplikasi Easycash, Anda dapat mengikuti langkah-langkah berikut ini:
</p>

<ol>
<li>Download aplikasi Easycash di <a href="https://play.google.com/store/apps/details?id=com.fintopia.idnEasycash.google&amp;pli=1" target="_blank">Google Play</a> atau <a href="https://apps.apple.com/id/app/id1435044790" target="_blank">App Store.</a></li>
<li>Masukkan nomor telepon Anda dan kode OTP akan dikirimkan. Kode OTP dapat diakses melalui SMS, pesan suara, dan juga WhatsApp.</li>
<li>Silakan isi data yang diperlukan di aplikasi Easycash.</li>
<li>Mohon menunggu proses verifikasi data.</li>
<li>Setelah Anda disetujui, silakan pilih nominal dan tenor pinjaman sesuai dengan kebutuhan Anda.</li>
<li>Pastikan kembali data dan dokumen yang Anda masukkan sesuai dengan persyaratan di aplikasi Easycash.</li>
</ol>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Dapatkah saya mengajukan lebih dari satu pinjaman?</label>
<div class="accordion-content">
<p>
Tergantung pada limit pinjaman yang Anda dapatkan. Silakan cek kembali secara berkala, dan pastikan menjaga riwayat pembayaran yang baik.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Mengapa pengajuan pinjaman saya tidak disetujui?</label>
<div class="accordion-content">
<p>
Apabila pengajuan Anda tidak lolos peninjauan, Anda belum memenuhi persyaratan pengajuan pinjaman. Silakan untuk melakukan pengecekan secara berkala di aplikasi Easycash.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck8">
<label class="accordion-label" for="chck8">Berapa nominal pinjaman yang dapat diajukan?</label>
<div class="accordion-content">
<p>
Nominal pinjaman yang dapat diajukan mulai dari Rp100.000 s/d Rp100.000.000.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck9">
<label class="accordion-label" for="chck9">Pencairan pinjaman Easycash</label>
<div class="accordion-content">
<p>
Perihal pencairan dana Anda, mohon menunggu maksimal 1 x 24 jam. Apabila sudah melebihi 1 x 24 jam masih belum terima, silakan lampirkan mutasi rekening dan hubungi Layanan Pelanggan Easycash di Call Center <a href="tel:1500866">1500866</a>, email: <a href="mailto: cs.pinjaman@easycash.id ">cs.pinjaman@easycash.id</a>, live chat pada aplikasi Easycash.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck10">
<label class="accordion-label" for="chck10">Apakah limit pinjaman saya dapat ditingkatkan?</label>
<div class="accordion-content">
<p>
Saat ini, nominal yang ditawarkan oleh Easycash sesuai dengan yang tertera pada aplikasi. Harap terus menjaga kredibilitas data Anda dengan melakukan pembayaran tepat waktu agar dapat mendapatkan tawaran-tawaran menarik dari kami.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck11">
<label class="accordion-label" for="chck11">Melalui apa saja pencairan dana di Easycash?</label>
<div class="accordion-content">
<p>
Untuk pencairan dana, dapat melalui bank yang tersedia pada aplikasi Easycash.
</p>
</div>
</div>

</div>

</div>

`;

export default faq;
